import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Redirect, Route } from "react-router-dom";

export const VLinkRoute = (props) => {
    const { component: Component, ...rest } = props;
    const { context, isVLinkAnalyst, isVLinkVendor, isVLinkSuperUser } = useContext(AuthContext);

    const isVLinkUser = isVLinkAnalyst(context.user) || isVLinkVendor(context.user) || isVLinkSuperUser(context.user);

    return (
        <Route
            {...rest}
            render={(props) =>
                isVLinkUser ? (
                    <Component {...props} {...rest} />
                ) : (
                    <Redirect
                        to={{
                            pathname: "/home",
                            state: { from: props.location },
                        }}
                    />
                )
            }
        />
    );
};
